import clsx from "clsx";

export default function Tabs({ onTextBodyChange, textDisplay, tabOptions }) {
  return (
    <div className="flex">
      {tabOptions.map((option) => {
        return (
          <div
            onClick={() => onTextBodyChange(option)}
            className={clsx(
              tabStyle +
                (textDisplay === option
                  ? " bg-blue"
                  : " bg-black/10 cursor-pointer")
            )}
          >
            <span className=" uppercase">{option}</span>
          </div>
        );
      })}
    </div>
  );
}

const tabStyle = clsx(
  "rounded-t-md px-4 py-2 text-xs font-bold tracking-wider mr-2 "
);
